//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AvatarTooltip",
  components: {
    ProfileAvatar
  },
  props: {
    tooltipData: {
      type: Array,
      required: true
    },
    visibleData: {
      type: Array,
      default() {
        return this.tooltipData;
      }
    },
    emptyMessage: {
      type: String,
      default: ""
    },
    placement: {
      type: String,
      default: "top"
    },
    thumbnailGroupClass: {
      type: String,
      default: ""
    }
  },
  computed: {
    hasData() {
      return this.tooltipData.length > 0;
    }
  },
  methods: {
    getAvatarTooltipTarget() {
      return this.$refs.avatarTooltip;
    }
  }
});